export default __webpack_public_path__ + "static/media/allery-1.9cf8882e.svg";